export default "__VITE_ASSET__CdwP975n__"